import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComponentCanDeactivate } from './component-can-deactivate';

export class BaseComponent implements OnDestroy {
    public subscriptions: Subscription[] = [];

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    protected toShortDateString(d: Date): string {
        if (!d){
            return  null;
        }
        return new Date(d).toISOString().slice(0, 10);
    }
}